import {Evaluator, GraphNodeReturning, registerNode} from "@cm/graph-v2-final"
import {ImageOpNode, ImageOpOutputs} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/utils/get-property/definition"

@registerNode
export class ImageOpNodeGetProperty<Returns> extends ImageOpNode<typeof definition> {
    static nodeClass = "ImageOpNodeGetProperty"
    static definition = definition

    override run = async (evaluator: Evaluator<unknown>): Promise<ImageOpOutputs<typeof definition>> => {
        const key = this.parameters.key
        const value = await evaluator.get(this.parameters.value as GraphNodeReturning<{[key in typeof key]: Returns}>)
        const parsedValue = this.definition.validation.returns.safeParse(value?.[key])
        if (!parsedValue.success) {
            throw new Error(`Failed to parse value: ${parsedValue.error.message}`)
        }
        return parsedValue.data
    }
}
